import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { AAVE_V3_COLLECTOR, ERC20_BALANCE_OF_REFERENCE_CALLDATA, } from "../fixture-inputs.js";
export const GNOSIS_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getBlockByNumberGnosis",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getBalanceGnosis",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getTokenBalanceGnosis",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.gnosis,
        fixture: "getBlockByHashGnosis",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getBlockTransactionsGnosis",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getTransfersGnosis",
    },
    simulateCallQuery: {
        to: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "simulateCallGnosis",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.gnosis,
        fixture: "traceTransactionGnosis",
    },
    tokenMetadataQuery: {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getTokenMetadataGnosis",
    },
    tokenAllowanceQuery: {
        token: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getTokenAllowanceGnosis",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.gnosis,
        fixture: "getReceiptGnosis",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.gnosis,
        fixture: "getTransactionByHashGnosis",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasGnosis",
    },
    codeQuery: {
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis,
        fixture: "getCodeGnosis",
    },
    logsQuery: {
        // Gnosis USDC.e — 50-block window to get meaningful log density.
        address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.gnosis - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.gnosis),
        fixture: "getLogsGnosis",
    },
    aaveV3Query: { address: AAVE_V3_COLLECTOR.gnosis, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis, fixture: "getAaveV3UserPositionsGnosis" },
    approvalsQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.gnosis, fixture: "getApprovalsGnosis" },
};
